/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationCompany
 */
export interface OrganizationCompany {
    /**
     * The ID of the company.
     * @type {string}
     * @memberof OrganizationCompany
     */
    id: string;
    /**
     * The name of the company.
     * @type {string}
     * @memberof OrganizationCompany
     */
    name: string;
    /**
     * The URL of the logo of the company, if any
     * @type {string}
     * @memberof OrganizationCompany
     */
    companyLogoUrl?: string;
}

/**
 * Check if a given object implements the OrganizationCompany interface.
 */
export function instanceOfOrganizationCompany(value: object): value is OrganizationCompany {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationCompanyFromJSON(json: any): OrganizationCompany {
    return OrganizationCompanyFromJSONTyped(json, false);
}

export function OrganizationCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'companyLogoUrl': json['companyLogoUrl'] == null ? undefined : json['companyLogoUrl'],
    };
}

export function OrganizationCompanyToJSON(value?: OrganizationCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'companyLogoUrl': value['companyLogoUrl'],
    };
}

